import { DetailPageErrorComponent } from "@/pages/details/DetailPageErrorComponent";
import { DetailPageParams } from "@/pages/details/schemata";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DetailPage } from "../../../../../../../pages/DetailPage";

const DetailPageViaGroupParams = z.object({
  groupId: z.coerce.number().int(),
  appId: DetailPageParams.shape.appId,
});

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/groups/$groupId/apps/$appId",
)({
  validateSearch: (search) => search,
  component: DetailPage,
  params: {
    parse: (params) => DetailPageViaGroupParams.parse(params),
  },
  errorComponent: DetailPageErrorComponent,
});
